import { Typography } from "@lyfegen-platform/react-common";
import { Box, makeStyles, Theme, Tooltip } from "@material-ui/core";
import { boxShadow } from "../../../hooks/use-map-theme-styles";
import FlexTypographyComponent from "../../FlexTypographyComponent";
import { caseStatusToColor, getCaseStatusIcon } from "../utils/status";

interface CaseStatusProps {
	props: any;
	palette: Theme["palette"];
	t: any;
}
interface LyfeTooltipProps {
	variant?: "dark" | "light";
}

const Text: React.FC<CaseStatusProps> = ({ props, palette, t }) => (
	<Typography
		type="status"
		style={{
			marginLeft: "2px",
			color: (props.status && caseStatusToColor(props.status, palette, true)) || "black",
		}}
	>
		<FlexTypographyComponent
			type="status"
			forceHideTooltip={Boolean(props.title) || undefined}
			text={!props.ignoreTranslation ? t(props.status) : props.text}
		/>
	</Typography>
);

const CaseStatus: React.FC<CaseStatusProps> = ({ props, palette, t }) => {
	const { variant, title, typographyProps, ...other } = props;
	const { tooltip } = classes({ variant: variant });

	return (
		<>
			<Tooltip
				enterDelay={100}
				leaveDelay={0}
				title={
					props.title ? (
						typeof props.title === "string" ? (
							<Typography {...props.typographyProps} type="semi-bold">
								{props.title}
							</Typography>
						) : (
							props.title
						)
					) : (
						""
					)
				}
				classes={{
					tooltip,
				}}
				{...other}
			>
				<Box
					display="flex"
					alignItems="center"
					style={{
						height: "22px",
						borderRadius: "100px",
						backgroundColor: caseStatusToColor(props?.status, palette),
						padding: "3px 8px 3px 6px",
						fontWeight: 600,
						maxWidth: "fit-content",
					}}
				>
					{props.before && (
						<>
							<Text props={props} palette={palette} t={t} />
							&nbsp;&nbsp;
						</>
					)}
					{getCaseStatusIcon(props.status)}
					{!props.before && (
						<>
							<Text props={props} palette={palette} t={t} />
						</>
					)}
				</Box>
			</Tooltip>
		</>
	);
};

const classes = makeStyles<Theme & LyfeTooltipProps>((theme: Theme) => {
	const { spacing, palette } = theme;
	return {
		tooltip: {
			backgroundColor: (props) =>
				(props as LyfeTooltipProps)?.variant === "light" ? "white" : (palette.toolTipBg as any)?.main || "black",
			color: (props) => ((props as LyfeTooltipProps)?.variant === "light" ? "black" : "white"),
			padding: spacing(1),
			boxShadow: boxShadow,
		},
	};
});

export default CaseStatus;
